import { useMutation } from '@tanstack/react-query'

import { ReactQueryHttpError } from '@sparkai/shared-types'

import { apiClient } from '../apiClient'

type MineSessionResponse = {
  date_created: string
  date_closed: string | null
  score: number
  isAssigned?: boolean
}

export function useMineSession(
  onSuccess: (data: MineSessionResponse) => void,
  onError: (err: ReactQueryHttpError) => void
) {
  return useMutation<MineSessionResponse>({
    mutationFn: async () => {
      const { data } = await apiClient.get<MineSessionResponse[]>(`/int/operator_session/mine`)
      return data[0]
    },
    onSuccess,
    onError,
  })
}
